import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const styles = {
  container: {
    display: 'flex',
    minHeight: '100vh',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  sidebar: {
    width: 220,
    backgroundColor: '#1a1a2e',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
  },
  logo: {
    padding: '20px 16px',
    fontSize: 20,
    fontWeight: 700,
    borderBottom: '1px solid rgba(255,255,255,0.1)',
    letterSpacing: '0.5px',
  },
  tenantName: {
    fontSize: 11,
    fontWeight: 400,
    color: 'rgba(255,255,255,0.5)',
    marginTop: 4,
    letterSpacing: 0,
  },
  nav: {
    flex: 1,
    padding: '12px 0',
  },
  navLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 16px',
    color: 'rgba(255,255,255,0.7)',
    textDecoration: 'none',
    fontSize: 14,
    transition: 'all 0.15s',
  },
  navLinkActive: {
    backgroundColor: 'rgba(255,255,255,0.1)',
    color: '#fff',
    borderRight: '3px solid #4a9eff',
  },
  navIcon: {
    width: 18,
    textAlign: 'center',
    fontSize: 15,
  },
  footer: {
    padding: '12px 16px',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    fontSize: 12,
    color: 'rgba(255,255,255,0.4)',
  },
  logoutBtn: {
    background: 'none',
    border: 'none',
    color: 'rgba(255,255,255,0.6)',
    cursor: 'pointer',
    fontSize: 12,
    padding: '4px 0',
  },
  main: {
    flex: 1,
    backgroundColor: '#f5f6fa',
    overflow: 'auto',
  },
  content: {
    padding: 24,
    maxWidth: 1200,
  },
};

const navItems = [
  { to: '/', label: 'Dashboard', icon: '\u25A0' },
  { to: '/titles', label: 'Titles', icon: '\u25B6' },
  { to: '/subscribers', label: 'Subscribers', icon: '\u263A' },
  { to: '/editions', label: 'Editions', icon: '\u25C6' },
  { to: '/renewals', label: 'Renewals', icon: '\u21BB' },
  { to: '/settings', label: 'Settings', icon: '\u2699' },
];

export default function Layout() {
  const { user, logout } = useAuth();

  return (
    <div style={styles.container}>
      <aside style={styles.sidebar}>
        <div style={styles.logo}>
          SubsData
          {user?.tenantName && (
            <div style={styles.tenantName}>{user.tenantName}</div>
          )}
        </div>
        <nav style={styles.nav}>
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              style={({ isActive }) => ({
                ...styles.navLink,
                ...(isActive ? styles.navLinkActive : {}),
              })}
            >
              <span style={styles.navIcon}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div style={styles.footer}>
          <div>{user?.username}</div>
          <button onClick={logout} style={styles.logoutBtn}>Sign out</button>
        </div>
      </aside>
      <main style={styles.main}>
        <div style={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
